import { event1, event2, event3, event4, event5, event6 } from "./assets/index";

export const events = [
  {
    id: 1,
    title: "Wonder Girls 2010 Wonder Girls World Tour San Francisco",
    date: "2023-04-14",
    location: "San Francisco, CA",
    imageUrl: event1,
    description:
      "We'll get you directly seated and inside for you to enjoy the show.",
    category: "Beach",
    eventType: "Tour",
    weekday: "Friday",
  },
  {
    id: 2,
    title: "JYJ 2011 JYJ Worldwide Concert Barcelona",
    date: "2023-08-20",
    location: "Barcelona, Spain",
    imageUrl: event2,
    description: "Directly seated and inside for you to enjoy the show.",
    category: "Concert",
    eventType: "Tour",
    weekday: "Sunday",
  },
  {
    id: 3,
    title: "2011 Super Junior SM Town Live '10 World Tour New York City",
    date: "2023-09-18",
    location: "New York City, NY",
    imageUrl: event3,
    description: "Directly seated and inside for you to enjoy the show.",
    category: "Parade",
    eventType: "Tour",
    weekday: "Monday",
  },
  {
    id: 4,
    title: "Wonder Girls 2010 Wonder Girls World Tour San Francisco",
    date: "2023-04-14",
    location: "San Francisco, CA",
    imageUrl: event4,
    description:
      "We'll get you directly seated and inside for you to enjoy the show.",
    category: "Concert",
    eventType: "Tour",
    weekday: "Friday",
  },
  {
    id: 5,
    title: "JYJ 2011 JYJ Worldwide Concert Barcelona",
    date: "2023-08-20",
    location: "Barcelona, Spain",
    imageUrl: event5,
    description: "Directly seated and inside for you to enjoy the show.",
    category: "Party",
    eventType: "Tour",
    weekday: "Sunday",
  },
  {
    id: 6,
    title: "2011 Super Junior SM Town Live '10 World Tour New York City",
    date: "2023-09-18",
    location: "New York City, NY",
    imageUrl: event6,
    description: "Directly seated and inside for you to enjoy the show.",
    category: "Disco",
    eventType: "Tour",
    weekday: "Monday",
  },
];
